export default __webpack_public_path__ + "static/card_reader_b.b840aa4cb1f564ee99281e55e2b6b78b.png";